import { render, staticRenderFns } from "./indicatorText_config.vue?vue&type=template&id=778f9264&"
import script from "./indicatorText_config.vue?vue&type=script&lang=js&"
export * from "./indicatorText_config.vue?vue&type=script&lang=js&"
import style0 from "./indicatorText_config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports